<template>
    <div class="home-content">
        <!-- 主视觉区 -->
        <section class="relative h-[480px] bg-gradient-to-br from-blue-900 via-blue-800 to-indigo-900 overflow-hidden"
            :style="{ minWidth: '280px' }">
            <!-- 背景纹理 -->
            <div class="absolute inset-0 opacity-20 group">
                <img alt="Abstract data network background" class="w-full h-full object-cover" id="img-1"
                    src="https://modao.cc/agent-py/media/generated_images/2025-12-19/49141a0a1ea1477d96cf9eedac86b284.jpg" />
            </div>
            <!-- 添加响应式flex方向 -->
            <div class="relative max-w-[1200px] mx-auto h-full px-4 flex flex-col md:flex-row items-center">
                <!-- 添加响应式类 -->
                <div class="w-full md:w-3/5 space-y-6">
                    <h2 class="text-4xl font-bold text-white leading-tight">
                        数据资产全过程管理<br />
                        <span class="text-blue-300">提供一站式数据价值化服务</span>
                    </h2>
                    <p class="text-blue-100 text-lg max-w-xl leading-relaxed hide-below-580">
                        平台以区块链存证、人工智能与大数据分析为核心技术底座，贯穿数据资产化管理全流程。从权威登记、智能合规、动态质量评估到市场化价值发现与金融对接，我们构建了技术赋能的可信价值闭环，确保每一环节可追溯、可审计、可验证，致力于为全国客户提供安全、高效的一站式数据价值实现服务。
                    </p>
                    <div class="flex space-x-4 pt-4">
                        <button @click="goToLiuCheng"
                            class="bg-blue-500 hover:bg-blue-400 text-white px-8 py-3 rounded shadow-lg transition-all flex items-center font-medium">
                            了解详情 <span class="iconify ml-2" data-icon="ri:arrow-right-line"></span>
                        </button>
                    </div>
                </div>
                <!-- 侧边功能入口 -->
                <div class="w-full md:w-2/5 flex flex-col items-center md:items-end space-y-4 mt-8 md:mt-0">
                    <div
                        class="w-full max-w-md md:w-64 bg-white/10 backdrop-blur-md p-6 rounded-xl border border-white/20 shadow-2xl space-y-4">
                        <button @click="toLogin"
                            class="w-full py-4 bg-blue-600 hover:bg-blue-500 text-white rounded-lg flex items-center justify-center space-x-3 transition-colors group">
                            <span class="iconify text-xl" data-icon="ri:edit-box-line"></span>
                            <span class="font-bold">我要登记</span>
                            <span class="iconify opacity-0 group-hover:opacity-100 transition-opacity"
                                data-icon="ri:arrow-right-s-line"></span>
                        </button>

                        <button @click="goToVerification"
                            class="w-full py-4 bg-cyan-600 hover:bg-cyan-500 text-white rounded-lg flex items-center justify-center space-x-3 transition-colors group">
                            <span class="iconify text-xl" data-icon="ri:shield-check-line"></span>
                            <span class="font-bold">我要查验</span>
                            <span class="iconify opacity-0 group-hover:opacity-100 transition-opacity"
                                data-icon="ri:arrow-right-s-line"></span>
                        </button>
                    </div>
                </div>
            </div>
        </section>



        <!-- 数据资产全过程流程图 -->
        <section class="py-24 bg-gray-50" id="liucheng-section">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-16">
                    <h3 class="text-3xl font-bold text-blue-900 flex items-center justify-center">
                        <span class="iconify mr-3 text-blue-600" data-icon="ri:flow-chart"></span>管理流程
                    </h3>
                    <p class="text-gray-600 text-lg mt-3 max-w-2xl mx-auto leading-relaxed">
                        从数据登记到价值实现的全链条闭环管理，助力企业构建数据资产新生态
                    </p>
                </div>

                <div class="relative">
                    <!-- 进度条背景 -->
                    <div
                        class="absolute top-24 left-0 w-full h-2 bg-gradient-to-r from-blue-500 via-purple-500 to-green-500 rounded-full opacity-20 -z-10">
                    </div>
                    <div
                        class="absolute top-24 left-0 w-full h-2 bg-gradient-to-r from-blue-500 via-purple-500 to-green-500 rounded-full opacity-30 -z-10 blur-sm">
                    </div>

                    <div class="grid grid-cols-1 md:grid-cols-5 gap-8">
                        <!-- 步骤 1 -->
                        <div class="flex flex-col items-center text-center group cursor-pointer">
                            <div class="relative mb-6">
                                <div
                                    class="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 shadow-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-all duration-300">
                                    <span class="iconify text-4xl text-white" data-icon="ri:file-list-3-line"></span>
                                </div>
                                <div
                                    class="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full shadow flex items-center justify-center border-2 border-blue-500">
                                    <span class="text-sm font-bold text-blue-600">1</span>
                                </div>
                            </div>
                            <h4
                                class="text-xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors">
                                数据登记</h4>
                            <div class="space-y-2">
                                <p class="text-sm text-gray-600 leading-relaxed">提交数据资源元数据，明确权属与物理属性，获得唯一数据资产身份标识。</p>
                                <ul class="text-xs text-gray-500 space-y-1">
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-blue-500" data-icon="ri:check-line"></span>
                                        标准化元数据描述
                                    </li>
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-blue-500" data-icon="ri:check-line"></span>
                                        区块链存证
                                    </li>
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-blue-500" data-icon="ri:check-line"></span>
                                        权属关系确认
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- 步骤 2 -->
                        <div class="flex flex-col items-center text-center group cursor-pointer">
                            <div class="relative mb-6">
                                <div
                                    class="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 shadow-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-all duration-300">
                                    <span class="iconify text-4xl text-white" data-icon="ri:shield-check-line"></span>
                                </div>
                                <div
                                    class="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full shadow flex items-center justify-center border-2 border-blue-500">
                                    <span class="text-sm font-bold text-blue-600">2</span>
                                </div>
                            </div>
                            <h4
                                class="text-xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors">
                                合规审查</h4>
                            <div class="space-y-2">
                                <p class="text-sm text-gray-600 leading-relaxed">多维度合规性评估，确保数据采集、处理、使用的合法性和安全性。</p>
                                <ul class="text-xs text-gray-500 space-y-1">
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-purple-500" data-icon="ri:check-line"></span>
                                        数据安全评估
                                    </li>
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-purple-500" data-icon="ri:check-line"></span>
                                        隐私合规审查
                                    </li>
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-purple-500" data-icon="ri:check-line"></span>
                                        政策符合性验证
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- 步骤 3 -->
                        <div class="flex flex-col items-center text-center group cursor-pointer">
                            <div class="relative mb-6">
                                <div
                                    class="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 shadow-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-all duration-300">
                                    <span class="iconify text-4xl text-white" data-icon="ri:medal-line"></span>
                                </div>
                                <div
                                    class="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full shadow flex items-center justify-center border-2 border-blue-500">
                                    <span class="text-sm font-bold text-blue-600">3</span>
                                </div>
                            </div>
                            <h4
                                class="text-xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors">
                                质量评价</h4>
                            <div class="space-y-2">
                                <p class="text-sm text-gray-600 leading-relaxed">通过智能算法评估数据质量，为数据资产等级和可信度提供权威背书。</p>
                                <ul class="text-xs text-gray-500 space-y-1">
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-green-500" data-icon="ri:check-line"></span>
                                        数据完整性检测
                                    </li>
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-green-500" data-icon="ri:check-line"></span>
                                        准确性验证
                                    </li>
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-green-500" data-icon="ri:check-line"></span>
                                        质量等级评定
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- 步骤 4 -->
                        <div class="flex flex-col items-center text-center group cursor-pointer">
                            <div class="relative mb-6">
                                <div
                                    class="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 shadow-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-all duration-300">
                                    <span class="iconify text-4xl text-white" data-icon="ri:calculator-line"></span>
                                </div>
                                <div
                                    class="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full shadow flex items-center justify-center border-2 border-blue-500">
                                    <span class="text-sm font-bold text-blue-600">4</span>
                                </div>
                            </div>
                            <h4
                                class="text-xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors">
                                价值评估</h4>
                            <div class="space-y-2">
                                <p class="text-sm text-gray-600 leading-relaxed">应用权威评估模型，科学核算数据资产的市场价值，为交易定价提供依据。</p>
                                <ul class="text-xs text-gray-500 space-y-1">
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-yellow-500" data-icon="ri:check-line"></span>
                                        多维度价值评估
                                    </li>
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-yellow-500" data-icon="ri:check-line"></span>
                                        公允价值测算
                                    </li>
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-yellow-500" data-icon="ri:check-line"></span>
                                        资产评估报告
                                    </li>
                                </ul>
                            </div>
                        </div>

                        <!-- 步骤 5 -->
                        <div class="flex flex-col items-center text-center group cursor-pointer">
                            <div class="relative mb-6">
                                <div
                                    class="w-20 h-20 rounded-full bg-gradient-to-br from-blue-500 to-blue-600 shadow-lg flex items-center justify-center mb-3 group-hover:scale-110 transition-all duration-300">
                                    <span class="iconify text-4xl text-white" data-icon="ri:bank-card-line"></span>
                                </div>
                                <div
                                    class="absolute -top-2 -right-2 w-8 h-8 bg-white rounded-full shadow flex items-center justify-center border-2 border-blue-500">
                                    <span class="text-sm font-bold text-blue-600">5</span>
                                </div>
                            </div>
                            <h4
                                class="text-xl font-bold text-gray-800 mb-3 group-hover:text-blue-600 transition-colors">
                                金融对接</h4>
                            <div class="space-y-2">
                                <p class="text-sm text-gray-600 leading-relaxed">链接金融机构，实现数据资产质押融资、证券化等金融创新服务。</p>
                                <ul class="text-xs text-gray-500 space-y-1">
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-red-500" data-icon="ri:check-line"></span>
                                        质押融资服务
                                    </li>
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-red-500" data-icon="ri:check-line"></span>
                                        资产证券化
                                    </li>
                                    <li class="flex items-center">
                                        <span class="iconify mr-1 text-red-500" data-icon="ri:check-line"></span>
                                        资本市场对接
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>



        <!-- 政策展示模块 -->
        <section class="py-16 bg-white">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-12">
                    <h3 class="text-3xl font-bold text-blue-900 flex items-center justify-center">
                        <span class="iconify mr-3 text-blue-600" data-icon="ri:megaphone-fill"></span>最新政策
                    </h3>
                    <p class="text-gray-600 text-lg mt-3 max-w-2xl mx-auto leading-relaxed">及时了解行业政策动态，把握数据资产化机遇</p>
                </div>
                <div class="flex flex-col md:flex-row gap-12 items-center">
                    <!-- 左侧轮播图 -->
                    <div class="w-full md:w-1/2">
                        <div class="relative rounded-2xl overflow-hidden shadow-xl aspect-[16/9] bg-blue-100 group"
                            @mouseenter="stopCarousel" @mouseleave="startCarousel">
                            <!-- 轮播图容器 -->
                            <div class="relative w-full h-full overflow-hidden">
                                <!-- 轮播图内容 -->
                                <div v-for="(slide, index) in policyData" :key="index" :class="['absolute inset-0 transition-opacity duration-500',
                                    currentSlide === index ? 'opacity-100 z-10' : 'opacity-0 z-0']"
                                    @click="openPolicyLink(slide.link)">
                                    <img :alt="slide.title" class="w-full h-full object-cover" :src="slide.image" />
                                    <div
                                        class="absolute inset-0 bg-gradient-to-t from-blue-900/60 to-transparent flex items-end p-8">
                                        <p class="text-white font-bold text-xl">{{ slide.title }}</p>
                                    </div>
                                </div>

                            </div>

                            <!-- 轮播图指示器 -->
                            <div class="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex space-x-2 z-20">
                                <button v-for="(slide, index) in policyData" :key="index" @click="goToSlide(index)"
                                    :class="['w-2 h-2 rounded-full transition-all duration-300',
                                        currentSlide === index ? 'bg-white w-6' : 'bg-white/50 hover:bg-white/80']"
                                    :aria-label="`跳转到第${index + 1}张`">
                                </button>
                            </div>

                            <!-- 导航按钮 - 默认隐藏，鼠标悬浮时显示 -->
                            <button @click="prevSlide"
                                class="absolute left-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center z-20 transition-all opacity-0 group-hover:opacity-100 translate-x-[-10px] group-hover:translate-x-0 duration-300">
                                <span class="iconify text-white text-xl transition-transform group-hover:scale-110"
                                    data-icon="ri:arrow-left-s-line"></span>
                            </button>
                            <button @click="nextSlide"
                                class="absolute right-4 top-1/2 transform -translate-y-1/2 w-10 h-10 bg-white/20 hover:bg-white/30 backdrop-blur-sm rounded-full flex items-center justify-center z-20 transition-all opacity-0 group-hover:opacity-100 translate-x-[10px] group-hover:translate-x-0 duration-300">
                                <span class="iconify text-white text-xl transition-transform group-hover:scale-110"
                                    data-icon="ri:arrow-right-s-line"></span>
                            </button>
                        </div>
                    </div>

                    <!-- 右侧公告列表 -->
                    <div class="w-full md:w-1/2 space-y-6">
                        <div class="flex justify-between items-center border-b border-gray-100 pb-4">
                            <h3 class="text-2xl font-bold text-gray-900 flex items-center">
                                <span class="w-2 h-8 bg-blue-600 rounded-full mr-3"></span>政策公告
                            </h3>
                            <!-- <a class="text-blue-600 hover:text-blue-700 text-sm font-medium" href="#">更多公告 &gt;</a> -->
                        </div>
                        <div class="space-y-6">
                            <div v-for="(policy, index) in displayedPolicyData" :key="index"
                                class="group cursor-pointer" @click="openPolicyLink(policy.link)">
                                <div class="flex justify-between items-start mb-1">
                                    <h4
                                        class="font-bold text-gray-800 group-hover:text-blue-600 transition-colors line-clamp-1">
                                        {{ policy.title }}</h4>
                                    <span class="text-sm text-gray-400 whitespace-nowrap ml-4">{{ policy.date }}</span>
                                </div>
                                <p class="text-sm text-gray-500 line-clamp-1">{{ policy.description }}</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>




        <!-- 登记公示预览 -->
        <section class="py-12 bg-white">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-12">
                    <h3 class="text-3xl font-bold text-blue-900 flex items-center justify-center">
                        <span class="iconify mr-3 text-blue-600" data-icon="ri:broadcast-fill"></span>登记信息
                    </h3>
                    <p class="text-gray-600 text-lg mt-3 max-w-2xl mx-auto leading-relaxed">实时展示最新登记的数据资产信息</p>
                </div>

                <!-- 加载状态 -->
                <div v-if="loading" class="flex flex-col items-center justify-center py-16">
                    <div class="relative">
                        <!-- 外圈旋转动画 -->
                        <div class="w-16 h-16 border-4 border-blue-100 rounded-full"></div>
                        <div
                            class="w-16 h-16 border-4 border-blue-500 border-t-transparent rounded-full animate-spin absolute top-0 left-0">
                        </div>
                        <!-- 内圈旋转动画 -->
                        <div class="w-10 h-10 border-3 border-blue-200 rounded-full absolute top-3 left-3"></div>
                        <div
                            class="w-10 h-10 border-3 border-blue-400 border-b-transparent rounded-full animate-spin-reverse absolute top-3 left-3">
                        </div>
                    </div>
                    <p class="mt-6 text-gray-600 font-medium">正在加载公示数据...</p>
                    <p class="text-sm text-gray-400 mt-2">请稍候，正在获取最新登记信息</p>
                </div>

                <!-- 数据表格（带过渡效果） -->
                <div v-else class="rounded-lg border border-gray-100 relative bg-gray-50/50 overflow-hidden fade-in">
                    <div class="h-[320px] overflow-hidden relative" ref="tableContainer" @mouseenter="pauseScroll"
                        @mouseleave="resumeScroll">
                        <!-- 固定表头 -->
                        <table class="w-full text-left bg-transparent sticky top-0 z-20">
                            <thead class="bg-gray-100/90 backdrop-blur-sm">
                                <tr>
                                    <th
                                        class="px-6 py-3 text-sm font-bold text-gray-800 text-center border-b-2 border-blue-300">
                                        登记数据名称</th>
                                    <th
                                        class="px-6 py-3 text-sm font-bold text-gray-800 text-center border-b-2 border-blue-300">
                                        所属行业</th>
                                    <th
                                        class="px-6 py-3 text-sm font-bold text-gray-800 text-center border-b-2 border-blue-300">
                                        登记主体</th>
                                    <th
                                        class="px-6 py-3 text-sm font-bold text-gray-800 text-center border-b-2 border-blue-300">
                                        登记日期</th>
                                </tr>
                            </thead>
                        </table>

                        <!-- 滚动的内容区域 -->
                        <div class="scroll-content" :class="{ 'scroll-paused': isPaused }">
                            <table class="w-full text-left bg-transparent">
                                <tbody class="divide-y divide-gray-100">
                                    <tr v-for="(item, index) in registrationData" :key="index" @click="showDetail(item)"
                                        :class="['hover:bg-blue-50/50 transition-colors', index % 2 === 0 ? 'bg-white' : 'bg-gray-50']">
                                        <td
                                            class="px-6 py-3 text-sm text-blue-500 text-center hover:underline cursor-pointer">
                                            {{ item.name }}</td>
                                        <td class="px-6 py-3 text-sm text-gray-700 text-center">{{ item.industry }}</td>
                                        <td class="px-6 py-3 text-sm text-gray-600 text-center">{{ item.registrant }}
                                        </td>
                                        <td class="px-6 py-3 text-sm text-gray-400 text-center">{{ item.date }}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </section>


        <!-- 企业活动模块 - 网格卡片式设计 -->
        <section class="py-20 bg-white" id="activity-section">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-16">
                    <h3 class="text-3xl font-bold text-blue-900 flex items-center justify-center">
                        <span class="iconify mr-3 text-blue-600" data-icon="ri:calendar-event-fill"></span>企业活动
                    </h3>
                    <p class="text-gray-600 text-lg mt-3 max-w-2xl mx-auto leading-relaxed">记录企业重要时刻，展示品牌实力与发展历程</p>
                </div>

                <!-- 活动筛选标签 -->
                <div class="flex flex-wrap justify-center gap-3 mb-12">
                    <button v-for="tag in allActivityTags" :key="tag" @click="filterActivities(tag)" :class="['px-4 py-2 rounded-full text-sm font-medium transition-all duration-300',
                        activeTag === tag ?
                            'bg-blue-600 text-white shadow-lg transform -translate-y-0.5' :
                            'bg-gray-100 text-gray-700 hover:bg-blue-100 hover:text-blue-700']">
                        {{ tag }}
                    </button>
                </div>

                <!-- 网格卡片布局 -->
                <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
                    <div v-for="(activity, index) in filteredActivityData" :key="index" class="group cursor-pointer"
                        @click="openActivityModal(activity)">
                        <!-- 修改：添加固定高度和弹性布局 -->
                        <div
                            class="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100 hover:shadow-xl transition-all duration-300 group-hover:scale-105 flex flex-col min-h-[400px]">

                            <!-- 图片区域 -->
                            <div class="relative h-48 overflow-hidden flex-shrink-0">
                                <img :alt="activity.title"
                                    class="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                                    :src="activity.image" />
                                <div
                                    class="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300">
                                </div>
                                <!-- 新活动标识 -->
                                <div v-if="isNewActivity(activity.date)"
                                    class="absolute top-3 right-3 bg-green-500 text-white text-xs px-2 py-1 rounded-full animate-pulse">
                                    最新
                                </div>
                                <!-- 日期标签 -->
                                <div
                                    class="absolute bottom-3 left-3 bg-white/90 backdrop-blur-sm px-3 py-1 rounded-full">
                                    <span class="text-sm font-medium text-gray-800">{{ formatActivityDate(activity.date)
                                    }}</span>
                                </div>
                            </div>

                            <!-- 内容区域 -->
                            <!-- 修改：使用flex-grow和overflow-hidden确保内容区域填充剩余空间 -->
                            <div class="p-6 flex-grow flex flex-col overflow-hidden">
                                <h4
                                    class="font-bold text-gray-800 text-lg mb-3 line-clamp-2 group-hover:text-blue-600 transition-colors">
                                    {{ activity.title }}
                                </h4>
                                <p class="text-gray-600 text-sm leading-relaxed line-clamp-2 mb-4 flex-grow">
                                    {{ activity.description }}
                                </p>
                                <!-- 标签 -->
                                <div class="flex flex-wrap gap-2 mt-auto">
                                    <span v-for="tag in activity.tags" :key="tag"
                                        class="px-2 py-1 bg-blue-50 text-blue-700 text-xs rounded-full font-medium">
                                        {{ tag }}
                                    </span>
                                    <!-- <span v-if="activity.tags.length > 2"
                                        class="px-2 py-1 bg-gray-100 text-gray-600 text-xs rounded-full">
                                        +{{ activity.tags.length - 2 }}
                                    </span> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- 加载更多按钮 -->
                <div class="text-center mt-12" v-if="filteredActivityData.length < activityData.length">
                    <button @click="loadMoreActivities"
                        class="px-8 py-3 bg-blue-600 hover:bg-blue-700 text-white font-medium rounded-lg transition-all transform hover:-translate-y-0.5">
                        加载更多活动
                    </button>
                </div>
            </div>
        </section>





        <!-- 平台核心价值 -->
        <section class="py-20 bg-gray-50">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-16">
                    <h3 class="text-3xl font-bold text-blue-900 flex items-center justify-center">
                        <span class="iconify mr-3 text-blue-600" data-icon="ri:trophy-fill"></span>核心价值
                    </h3>
                    <p class="text-gray-600 text-lg mt-3 max-w-3xl mx-auto leading-relaxed">
                        权威数据资产登记认证平台，构建从数据资源登记到价值实现的全链条生态体系</p>
                </div>
                <div class="grid grid-cols-1 lg:grid-cols-2 gap-8">
                    <!-- 左侧核心价值展示 -->
                    <div class="space-y-6">
                        <div
                            class="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all group">
                            <div class="flex items-start space-x-4">
                                <div
                                    class="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-blue-500 to-blue-600 rounded-xl flex items-center justify-center">
                                    <span class="iconify text-3xl text-white" data-icon="ri:shield-check-line"></span>
                                </div>
                                <div>
                                    <h4 class="text-xl font-bold text-gray-900 mb-3">数据权属清晰化</h4>
                                    <div class="space-y-2">
                                        <p class="text-gray-600 leading-relaxed">
                                            通过区块链技术实现数据资源持有权、加工使用权、产品经营权的"三权分置"，构建清晰的数据资产权属体系。</p>
                                        <div class="flex flex-wrap gap-2 mt-3">
                                            <span
                                                class="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-medium">区块链存证</span>
                                            <span
                                                class="px-3 py-1 bg-green-50 text-green-700 rounded-full text-xs font-medium">三权分置</span>
                                            <span
                                                class="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-xs font-medium">权属明晰</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all group">
                            <div class="flex items-start space-x-4">
                                <div
                                    class="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-green-500 to-green-600 rounded-xl flex items-center justify-center">
                                    <span class="iconify text-3xl text-white" data-icon="ri:exchange-funds-line"></span>
                                </div>
                                <div>
                                    <h4 class="text-xl font-bold text-gray-900 mb-3">流通效率倍增</h4>
                                    <div class="space-y-2">
                                        <p class="text-gray-600 leading-relaxed">
                                            标准化元数据体系降低供需对接成本，缩短数据交易周期60%以上，实现数据要素高效配置和市场流转。</p>
                                        <div class="flex flex-wrap gap-2 mt-3">
                                            <span
                                                class="px-3 py-1 bg-green-50 text-green-700 rounded-full text-xs font-medium">标准统一</span>
                                            <span
                                                class="px-3 py-1 bg-blue-50 text-blue-700 rounded-full text-xs font-medium">成本降低60%</span>
                                            <span
                                                class="px-3 py-1 bg-orange-50 text-orange-700 rounded-full text-xs font-medium">快速流转</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <!-- 右侧价值展示 -->
                    <div class="space-y-6">
                        <div
                            class="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all group">
                            <div class="flex items-start space-x-4">
                                <div
                                    class="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-purple-500 to-purple-600 rounded-xl flex items-center justify-center">
                                    <span class="iconify text-3xl text-white" data-icon="ri:calculator-line"></span>
                                </div>
                                <div>
                                    <h4 class="text-xl font-bold text-gray-900 mb-3">财务价值激活</h4>
                                    <div class="space-y-2">
                                        <p class="text-gray-600 leading-relaxed">
                                            符合会计准则要求的数据资产入表路径，支持质押融资、资产证券化等金融创新，释放数据资产的资本属性。</p>
                                        <div class="flex flex-wrap gap-2 mt-3">
                                            <span
                                                class="px-3 py-1 bg-purple-50 text-purple-700 rounded-full text-xs font-medium">资产入表</span>
                                            <span
                                                class="px-3 py-1 bg-red-50 text-red-700 rounded-full text-xs font-medium">质押融资</span>
                                            <span
                                                class="px-3 py-1 bg-yellow-50 text-yellow-700 rounded-full text-xs font-medium">资本运作</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <div
                            class="bg-white rounded-2xl p-8 shadow-lg border border-gray-100 hover:shadow-xl transition-all group">
                            <div class="flex items-start space-x-4">
                                <div
                                    class="flex-shrink-0 w-16 h-16 bg-gradient-to-br from-orange-500 to-orange-600 rounded-xl flex items-center justify-center">
                                    <span class="iconify text-3xl text-white" data-icon="ri:bank-card-line"></span>
                                </div>
                                <div>
                                    <h4 class="text-xl font-bold text-gray-900 mb-3">价值持续增值</h4>
                                    <div class="space-y-2">
                                        <p class="text-gray-600 leading-relaxed">
                                            构建数据资产全生命周期管理体系，通过持续的质量提升和价值挖掘，实现数据资产的长期增值和收益变现。</p>
                                        <div class="flex flex-wrap gap-2 mt-3">
                                            <span
                                                class="px-3 py-1 bg-orange-50 text-orange-700 rounded-full text-xs font-medium">生命周期管理</span>
                                            <span
                                                class="px-3 py-1 bg-teal-50 text-teal-700 rounded-full text-xs font-medium">持续增值</span>
                                            <span
                                                class="px-3 py-1 bg-pink-50 text-pink-700 rounded-full text-xs font-medium">收益变现</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>

        <!-- 查验模块 -->
        <section class="py-16 bg-white" id="verification-section">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-12">
                    <h3 class="text-3xl font-bold text-blue-900 flex items-center justify-center">
                        <span class="iconify mr-3 text-blue-600" data-icon="ri:shield-check-fill"></span>数据资产存证
                    </h3>
                    <p class="text-gray-600 text-lg mt-3 max-w-2xl mx-auto leading-relaxed">轻松验证数据资产登记的真实性与完整性</p>
                </div>
                <div
                    class="bg-white border border-blue-100 rounded-2xl shadow-sm p-8 flex flex-col md:flex-row items-center gap-10">
                    <div
                        class="w-24 h-24 bg-blue-600 rounded-2xl flex items-center justify-center flex-shrink-0 shadow-lg shadow-blue-200">
                        <span class="iconify text-5xl text-white" data-icon="ri:lock-password-line"></span>
                    </div>
                    <div class="flex-grow space-y-4">
                        <h3 class="text-2xl font-bold text-blue-900">查验通道</h3>
                        <p class="text-gray-600 leading-relaxed">
                            平台深度对接<span
                                class="font-bold text-blue-700">蚂蚁链（AntChain）</span>等核心区块链技术底座，确保所有登记存证环节数据具有<span
                                class="text-blue-800 font-medium">真实性、不可篡改性及全程可追溯性</span>。每一份登记凭证均拥有唯一的链上身份ID，支持多方实时在线核验及存证报告下载。
                        </p>
                        <div class="flex flex-wrap gap-6 text-sm">
                            <span
                                class="flex items-center py-1.5 px-3 bg-green-50 text-green-700 rounded-full font-medium border border-green-100">
                                <span class="iconify mr-1.5" data-icon="ri:shield-check-fill"></span>蚂蚁链技术支撑
                            </span>
                            <span
                                class="flex items-center py-1.5 px-3 bg-blue-50 text-blue-700 rounded-full font-medium border border-blue-100">
                                <span class="iconify mr-1.5" data-icon="ri:history-line"></span>全链路可信追溯
                            </span>
                            <span
                                class="flex items-center py-1.5 px-3 bg-purple-50 text-purple-700 rounded-full font-medium border border-purple-100">
                                <span class="iconify mr-1.5" data-icon="ri:government-line"></span>存证法律效力
                            </span>
                        </div>
                    </div>
                    <div class="flex-shrink-0">
                        <button @click="toRegistration"
                            class="px-10 py-4 bg-blue-700 hover:bg-blue-800 text-white font-bold rounded-lg transition-all transform hover:-translate-y-0.5 shadow-md flex items-center">
                            <span class="iconify mr-2 text-xl" data-icon="ri:search-eye-line"></span>
                            数据资产查验
                        </button>
                    </div>
                </div>
            </div>
        </section>

        <!-- 数据资产登记互认链 -->
        <section class="py-20 bg-gray-50">
            <div class="max-w-[1200px] mx-auto px-4">
                <div class="text-center mb-12">
                    <h3 class="text-3xl font-bold text-blue-900 flex items-center justify-center">
                        <span class="iconify mr-3 text-blue-600" data-icon="ri:global-line"></span>登记互认链
                    </h3>
                    <p class="text-gray-600 text-lg mt-3 max-w-2xl mx-auto leading-relaxed">构建全国统一的数据资产登记生态体系</p>
                </div>
                <div class="bg-white border-2 border-gray-100 rounded-2xl p-12 relative overflow-hidden shadow-lg">
                    <!-- 浅色地图背景 -->
                    <div class="absolute inset-0 bg-gradient-to-br from-blue-50/30 via-white to-gray-50/40"></div>
                    <!-- 中国地图背景 -->
                    <div class="absolute inset-0 opacity-[0.03]">
                        <svg width="100%" height="100%" viewBox="0 0 280 200" preserveAspectRatio="xMidYMid slice">
                            <!-- 中国地图简化轮廓 -->
                            <path
                                d="M50,50 L80,45 L100,60 L120,55 L140,70 L160,65 L180,80 L200,75 L220,90 L240,85 L260,100 L230,120 L210,110 L190,125 L170,115 L150,130 L130,120 L110,135 L90,125 L70,140 L50,130 L40,110 L30,90 L40,70 Z"
                                fill="#1e40af" stroke="#3b82f6" stroke-width="0.5" />
                            <!-- 互认节点标注 -->
                            <circle cx="100" cy="60" r="4" fill="#10b981" stroke="#3b82f6" stroke-width="1" />
                            <circle cx="150" cy="90" r="4" fill="#10b981" stroke="#3b82f6" stroke-width="1" />
                            <circle cx="200" cy="75" r="4" fill="#10b981" stroke="#3b82f6" stroke-width="1" />
                            <circle cx="180" cy="125" r="4" fill="#f59e0b" stroke="#3b82f6" stroke-width="1" />
                            <circle cx="120" cy="110" r="4" fill="#10b981" stroke="#3b82f6" stroke-width="1" />
                            <circle cx="70" cy="130" r="4" fill="#f59e0b" stroke="#3b82f6" stroke-width="1" />
                            <!-- 连接线 -->
                            <line x1="100" y1="60" x2="150" y2="90" stroke="#3b82f6" stroke-width="1"
                                stroke-dasharray="2 2" />
                            <line x1="150" y1="90" x2="200" y2="75" stroke="#3b82f6" stroke-width="1"
                                stroke-dasharray="2 2" />
                            <line x1="200" y1="75" x2="180" y2="125" stroke="#3b82f6" stroke-width="1"
                                stroke-dasharray="2 2" />
                            <line x1="180" y1="125" x2="120" y2="110" stroke="#3b82f6" stroke-width="1"
                                stroke-dasharray="2 2" />
                            <line x1="120" y1="110" x2="70" y2="130" stroke="#3b82f6" stroke-width="1"
                                stroke-dasharray="2 2" />
                            <line x1="70" y1="130" x2="100" y2="60" stroke="#3b82f6" stroke-width="1"
                                stroke-dasharray="2 2" />
                        </svg>
                    </div>
                    <div class="relative z-10 flex flex-col lg:flex-row items-center justify-between gap-8">
                        <!-- 左侧内容 -->
                        <div class="lg:w-1/2 space-y-6">
                            <h4 class="text-2xl font-bold text-blue-900 flex items-center mb-4">
                                <span class="iconify mr-3 text-blue-600" data-icon="ri:node-tree"></span>全国互认节点网络
                            </h4>
                            <p class="text-gray-600 leading-relaxed">
                                目前已有<span
                                    class="font-bold text-blue-800">北京、上海、广东、陕西、河北</span>等12个省市公共数据资源服务平台正式加入"互认链"，成功实现跨区域登记标准统一、存证凭证互认，构建全国数据资产化一张网。
                            </p>
                            <div class="bg-gray-50 rounded-lg p-4 border border-gray-200">
                                <div class="flex flex-wrap gap-2 justify-center">
                                    <span
                                        class="px-3 py-2 bg-blue-100 text-blue-800 rounded-lg text-sm font-medium flex items-center">
                                        <span class="iconify mr-2 text-blue-600"
                                            data-icon="ri:check-double-line"></span>京津冀地区已互认
                                    </span>
                                    <span
                                        class="px-3 py-2 bg-green-100 text-green-800 rounded-lg text-sm font-medium flex items-center">
                                        <span class="iconify mr-2 text-green-600"
                                            data-icon="ri:check-double-line"></span>长三角互联互通
                                    </span>
                                    <span
                                        class="px-3 py-2 bg-purple-100 text-purple-800 rounded-lg text-sm font-medium flex items-center">
                                        <span class="iconify mr-2 text-purple-600"
                                            data-icon="ri:check-double-line"></span>成渝双城链合
                                    </span>
                                </div>
                            </div>
                        </div>
                        <!-- 右侧地图展示 -->
                        <div style="width: 500px;">
                            <div class="bg-white p-6 rounded-xl border border-gray-200 shadow-sm">
                                <div class="text-center mb-4">
                                    <h5 class="font-bold text-gray-800 flex items-center justify-center">
                                        <span class="iconify mr-2 text-blue-600"
                                            data-icon="ri:map-pin-2-line"></span>全国互认节点分布图
                                    </h5>
                                </div>
                                <div class="relative">
                                    <!-- 使用真实的中国地图图片 -->
                                    <img alt="中国地图互认节点分布图" class="w-full h-64 object-cover object-center"
                                        src="../../assets/img/homePage/home_map.png" />
                                    <!-- <div class="absolute inset-0 flex items-center justify-center">
                                        <div class="relative w-16 h-16">
                                            <div
                                                class="absolute top-1/4 left-1/4 w-3 h-3 bg-green-500 rounded-full border-2 border-white shadow-lg animate-pulse">
                                            </div>
                                            <div
                                                class="absolute top-1/3 right-1/4 w-3 h-3 bg-green-500 rounded-full border-2 border-white shadow-lg animate-pulse">
                                            </div>
                                            <div
                                                class="absolute bottom-1/3 left-1/3 w-3 h-3 bg-green-500 rounded-full border-2 border-white shadow-lg animate-pulse">
                                            </div>
                                            <div
                                                class="absolute top-1/2 right-1/3 w-3 h-3 bg-yellow-500 rounded-full border-2 border-white shadow-lg animate-pulse">
                                            </div>
                                            <div
                                                class="absolute bottom-1/4 left-1/2 w-3 h-3 bg-green-500 rounded-full border-2 border-white shadow-lg animate-pulse">
                                            </div>
                                            <div
                                                class="absolute top-1/4 right-1/4 w-3 h-3 bg-yellow-500 rounded-full border-2 border-white shadow-lg animate-pulse">
                                            </div>
                                        </div>
                                    </div> -->
                                    <!-- <div class="mt-4 flex flex-wrap justify-center gap-2 text-xs">
                                        <div class="flex items-center">
                                            <div class="w-3 h-3 bg-green-500 rounded-full mr-1"></div>
                                            <span class="text-gray-600">已互认地区</span>
                                        </div>
                                        <div class="flex items-center">
                                            <div class="w-3 h-3 bg-yellow-500 rounded-full mr-1"></div>
                                            <span class="text-gray-600">即将互认地区</span>
                                        </div>
                                    </div> -->
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
export default {
    name: 'HomeContent',
    data() {
        return {
            registrationData: [],
            loading: false,
            currentPage: 1,
            pageSize: 40,
            isPaused: false,
            policyData: [], // 初始化为空数组
            showTable: false, // ：控制表格显示
            currentSlide: 0,
            policyData: [
                {
                    title: '国家数据局部署2026年重点工作（全国数据工作会议）',
                    date: '2025-12-30',
                    description: '指明最新政策方向，提出"加快建立全国统一的数据产权登记制度"，是未来制度建设的纲领。',
                    link: 'https://www.gov.cn/lianbo/202512/content_7053258.htm',
                    image: require('@/assets/news_imgs/1.png')

                },
                {
                    title: '财政部印发指导意见加强数据资产管理',
                    date: '2024-01-16',
                    description: '指导意见主要包括总体要求、主要任务、实施保障等三方面十八条内容。',
                    link: 'https://www.mof.gov.cn/zhengwuxinxi/caijingshidian/xinhuanet/202401/t20240116_3925965.htm',
                    image: require('@/assets/news_imgs/2.png')
                },
                {
                    title: '河北省数据知识产权地方试点工作（保定市成果）  ',
                    date: '2025-01-07',
                    description: '保定市在数据知识产权登记方面成果显著，累计获得证书数占全省15%。这为数据资产的权属确认提供了另一种重要路径。',
                    link: 'https://ipr.mofcom.gov.cn/article/gnxw/zfbm/zfbmdf/hb/202501/1989946.html',
                    image: require('@/assets/news_imgs/3.png')
                },
                {
                    title: '《保定市推进数据智能产业创新发展措施》',
                    date: '2025-09-02',
                    description: '包含12条支持措施，其中明确提出通过发放"数智券"等方式，支持企业开展数据产权登记、数据资产融资等活动。',
                    link: 'https://www.tangxian.gov.cn/zwgknr-1541-3925666.html',
                    image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80&w=800'
                },
                {
                    title: '《数据要素全过程管理》工作指引',
                    date: '2025-10-17',
                    description: '由保定市竞秀区主导发布，提供数据从资源到资产再到资本的全流程操作指南，涵盖登记、评估、融资等关键环节，本地实践指导性强。',
                    link: 'https://bd.hebnews.cn/2025-10/20/content_9406631.htm',
                    image: require('@/assets/news_imgs/4.jpeg')
                }

            ],
            // 企业活动数据
            activityData: [
                {
                    title: '铜仁市大数据发展管理局开展参观调研',
                    date: '2025-07-23',
                    description: '铜仁市大数据发展管理局到访保定市企服数据资产认证登记评价中心开展参观调研。',
                    image: require('@/assets/news_imgs/7.jpg'),
                    tags: ['政府调研', '领导视察', '区域合作']
                },
                {
                    title: '亮相中国国际大数据产业博览会',
                    date: '2025-10-18',
                    description: '保定市企服数据要素研究院受邀亮相 2025 中国国际大数据产业博览会。',
                    image: require('@/assets/news_imgs/5.jpg'),
                    tags: ['行业峰会', '数据流通']
                },
                {
                    title: '廊坊市数据局莅临登记评价中心',
                    date: '2025-08-10',
                    description: '廊坊市数据局一行莅临保定市企服数据资产认证登记评价中心参观学习。',
                    image: require('@/assets/news_imgs/6.jpg'),
                    tags: ['政府调研', '业务交流', '区域合作']
                }
            ],
            // 活动相关数据
            activeActivityIndex: 0,
            activityCarouselInterval: null,
            activeTag: '全部',
            displayCount: 6, // 初始显示数量
            allActivityTags: ['全部', '政府调研', '区域合作', '行业峰会', '业务交流', '数据流通']
        }
    },
    mounted() {
        this.fetchData()
        this.startCarousel();
        this.startActivityCarousel();
        this.fetchPolicyData(); // 新增：获取政策数据
    },
    beforeDestroy() {
        this.stopCarousel();
        this.stopActivityCarousel();
    },
    computed: {
        // 新增计算属性：只返回前3条政策数据
        displayedPolicyData() {
            return this.policyData.slice(0, 3);
        },
        // 企业活动数据计算属性
        displayedActivityData() {
            return this.activityData.slice(0, 5);
        },
        // 筛选后的活动数据
        filteredActivityData() {
            let filtered = this.activityData;

            if (this.activeTag !== '全部') {
                filtered = filtered.filter(activity =>
                    activity.tags.includes(this.activeTag)
                );
            }

            return filtered.slice(0, this.displayCount);
        }
    },
    methods: {


        async fetchData() {
            try {
                this.loading = true;
                this.showTable = false; // 隐藏表格
                const params = {
                    currPage: this.currentPage,
                    pageSize: this.pageSize
                };

                const temp = await this.$axios.get('/web/page/certificate/queryPublicityListWithSize', {
                    params,
                    paramsSerializer: params => {
                        return Object.entries(params)
                            .filter(([_, value]) => value !== undefined && value !== '')
                            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                            .join('&');
                    }
                });

                this.pageSize = temp.data.total;
                params.pageSize = this.pageSize;

                const res = await this.$axios.get('/web/page/certificate/queryPublicityListWithSize', {
                    params,
                    paramsSerializer: params => {
                        return Object.entries(params)
                            .filter(([_, value]) => value !== undefined && value !== '')
                            .map(([key, value]) => `${key}=${encodeURIComponent(value)}`)
                            .join('&');
                    }
                });
                // console.log("res.data.certificateId");
                // console.log(res.data.certificateId);

                // 将API数据转换为表格需要的格式
                this.registrationData = (res.data?.list || []).map(item => ({
                    name: item.assetName,
                    industry: item.dataSource,
                    registrant: item.companyName,
                    date: item.registrationDate,
                    registrationId: item.certificateId,
                }));

                // 数据加载完成后，延迟显示表格以实现平滑过渡
                setTimeout(() => {
                    this.loading = false;
                    // 使用setTimeout确保DOM更新后再显示表格
                    this.$nextTick(() => {
                        setTimeout(() => {
                            this.showTable = true;
                        }, 50);
                    });
                }, 300); // 增加一点延迟让加载动画更明显

            } catch (error) {
                console.error('获取公示数据失败:', error);
                this.$message.error('获取公示数据失败');
                // 如果API失败，使用模拟数据作为后备
                this.registrationData = this.getFallbackData();
            } finally {
                this.loading = false;
            }
        },
        showDetail(item) {
            console.log('查看详情:', item);
            // 这里可以添加显示详情的逻辑，比如打开弹窗或跳转页面
            console.log(`查看详情: ${item.assetName}\n登记编号: ${item.registrationId || item.certificateId}`);
            this.$router.push(`/assetDetail/${item.registrationId}`)
            // 立即滚动到顶部
            window.scrollTo(0, 0);
        },
        // 新增：获取政策数据的方法
        async fetchPolicyData() {
            try {
                const response = await this.$axios.get('/web/announcement/queryList');

                if (response.data && response.data.object) {
                    // 将API返回的数据转换为组件需要的格式
                    this.policyData = response.data.object.map(item => ({
                        title: item.contentBrief,
                        date: item.publishTime ? item.publishTime.split(' ')[0] : '', // 只取日期部分
                        description: item.contentDetail,
                        link: item.linkUrl,
                        image: item.imageUrl || this.getDefaultImage() // 使用API图片或默认图片
                    }));

                    // 启动轮播
                    this.startCarousel();
                }
            } catch (error) {
                console.error('获取政策数据失败:', error);
                // 如果API失败，使用默认数据作为后备
                this.policyData = this.getDefaultPolicyData();
            }
        },

        // 新增：获取默认图片的方法
        getDefaultImage() {
            // 这里可以设置一个默认图片
            return 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?auto=format&fit=crop&q=80&w=800';
        },

        // 新增：默认政策数据（作为后备）
        getDefaultPolicyData() {
            return [
                {
                    title: '国家数据局部署2026年重点工作（全国数据工作会议）',
                    date: '2025-12-30',
                    description: '指明最新政策方向，提出"加快建立全国统一的数据产权登记制度"，是未来制度建设的纲领。',
                    link: 'https://www.gov.cn/lianbo/202512/content_7053258.htm',
                    image: this.getDefaultImage()
                },
                {
                    title: '财政部印发指导意见加强数据资产管理',
                    date: '2024-01-16',
                    description: '指导意见主要包括总体要求、主要任务、实施保障等三方面十八条内容。',
                    link: 'https://www.mof.gov.cn/zhengwuxinxi/caijingshidian/xinhuanet/202401/t20240116_3925965.htm',
                    image: this.getDefaultImage()
                }
            ];
        },
        getFallbackData() {
            return [
                { name: '智慧秤长时间未登录监管预警数据集', industry: '其他服务业', registrant: '保定朗仕捷供应链管理有限公司', date: '2025年11月13日' },
                { name: '市场智慧化自动结算与统计数据集', industry: '其他服务业', registrant: '保定朗仕捷供应链管理有限公司', date: '2025年11月13日' },
                { name: '市场需求预测数据集', industry: '其他服务业', registrant: '保定朗仕捷供应链管理有限公司', date: '2025年11月13日' },
                { name: '市场客流量分析数据集', industry: '其他服务业', registrant: '保定朗仕捷供应链管理有限公司', date: '2025年11月13日' },
                { name: '商户诚信评级数据集', industry: '其他服务业', registrant: '保定朗仕捷供应链管理有限公司', date: '2025年11月13日' },
                { name: '交易价格监管数据集', industry: '其他服务业', registrant: '保定朗仕捷供应链管理有限公司', date: '2025年11月13日' },
                { name: '中药材产地溯源分析数据集', industry: '其他服务业', registrant: '保定朗仕捷供应链管理有限公司', date: '2025年11月13日' },
                { name: '智慧监管公平秤复称投诉统计数据集', industry: '其他服务业', registrant: '保定朗仕捷供应链管理有限公司', date: '2025年11月13日' },
                { name: '用户购买行为分析数据集', industry: '其他服务业', registrant: '保定朗仕捷供应链管理有限公司', date: '2025年11月13日' },
                { name: '市场价格公示预警监管数据集', industry: '其他服务业', registrant: '保定朗仕捷供应链管理有限公司', date: '2025年11月13日' }
            ];
        },
        pauseScroll() {
            this.isPaused = true;
        },
        resumeScroll() {
            this.isPaused = false;
        },
        toLogin() {
            this.$router.push('/login');
        },
        toRegistration() {
            this.$router.push('/registration');
            // 延迟执行，确保导航栏已渲染
            this.$nextTick(() => {
                // 查找导航栏组件并触发跳转
                const navBar = document.querySelector('.navigation-bar');
                if (navBar && navBar.__vue__) {
                    // 调用导航栏的 handleSelect 方法
                    navBar.__vue__.handleSelect('2');
                }

                // 延迟滚动到登记信息公示位置
                setTimeout(() => {
                    this.scrollToPublicitySection();
                }, 100); // 增加一点延迟确保页面已加载
            });
        },

        // 新增：滚动到登记信息公示位置的方法
        scrollToPublicitySection() {
            // 等待页面完全加载
            if (document.readyState === 'complete') {
                this.performScroll();
            } else {
                window.addEventListener('load', () => {
                    this.performScroll();
                });
            }
        },

        performScroll() {
            const publicitySection = document.getElementById('publicity-section');
            if (publicitySection) {
                // 平滑滚动到指定位置，减去导航栏高度
                const navHeight = document.querySelector('.navigation-bar')?.offsetHeight || 0;
                const targetPosition = publicitySection.offsetTop - navHeight + 100;

                window.scrollTo({
                    top: targetPosition,
                    behavior: 'smooth'
                });
            } else {
                // 如果找不到锚点，尝试其他方式
                console.log('未找到登记信息公示区域');
            }
        },


        goToVerification() {
            // 方法1：使用路由跳转（如果页面存在）
            // this.$router.push('/verification');

            // 方法2：使用锚点跳转到页面内的查验模块
            const verificationSection = document.getElementById('verification-section');
            if (verificationSection) {
                verificationSection.scrollIntoView({ behavior: 'smooth' });
            } else {
                // 如果找不到锚点，滚动到查验模块的位置
                window.scrollTo({
                    top: document.querySelector('section.py-16.bg-white').offsetTop - 80,
                    behavior: 'smooth'
                });
            }
        },
        goToLiuCheng() {
            // 方法1：使用路由跳转（如果页面存在）
            // this.$router.push('/verification');

            // 方法2：使用锚点跳转到页面内的查验模块
            const verificationSection = document.getElementById('liucheng-section');
            if (verificationSection) {
                verificationSection.scrollIntoView({ behavior: 'smooth' });
            } else {
                // 如果找不到锚点，滚动到查验模块的位置
                window.scrollTo({
                    top: document.querySelector('section.py-16.bg-white').offsetTop - 80,
                    behavior: 'smooth'
                });
            }
        },

        openPolicyLink(link) {
            if (link) {
                window.open(link, '_blank', 'noopener,noreferrer');
            }
        },

        // 新增：轮播图方法
        startCarousel() {
            this.carouselInterval = setInterval(() => {
                this.nextSlide();
            }, 5000); // 5秒自动切换
        },

        stopCarousel() {
            if (this.carouselInterval) {
                clearInterval(this.carouselInterval);
                this.carouselInterval = null;
            }
        },

        nextSlide() {
            this.currentSlide = (this.currentSlide + 1) % this.policyData.length;
        },

        prevSlide() {
            this.currentSlide = (this.currentSlide - 1 + this.policyData.length) % this.policyData.length;
        },

        goToSlide(index) {
            this.currentSlide = index;
        },

        // 企业活动相关方法
        startActivityCarousel() {
            this.activityCarouselInterval = setInterval(() => {
                this.nextActivity();
            }, 4000); // 4秒自动切换，比政策轮播快一点
        },

        stopActivityCarousel() {
            if (this.activityCarouselInterval) {
                clearInterval(this.activityCarouselInterval);
                this.activityCarouselInterval = null;
            }
        },

        nextActivity() {
            this.activeActivityIndex = (this.activeActivityIndex + 1) % this.activityData.length;
        },

        prevActivity() {
            this.activeActivityIndex = (this.activeActivityIndex - 1 + this.activityData.length) % this.activityData.length;
        },

        scrollToActivity(index) {
            this.activeActivityIndex = index;
        },

        formatActivityDate(date) {
            const dateObj = new Date(date);
            return `${dateObj.getFullYear()}年${dateObj.getMonth() + 1}月${dateObj.getDate()}日`;
        },

        isNewActivity(date) {
            const activityDate = new Date(date);
            const now = new Date();
            const diffTime = Math.abs(now - activityDate);
            const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
            return diffDays <= 30; // 30天内为新活动
        },

        getActiveActivityTags() {
            return this.activityData[this.activeActivityIndex]?.tags || [];
        },

        // 新增加的方法
        filterActivities(tag) {
            this.activeTag = tag;
            this.displayCount = 6; // 重置显示数量
        },

        loadMoreActivities() {
            this.displayCount += 3;
        },

        openActivityModal(activity) {
            // 这里可以打开模态框显示活动详情
            // 暂时用控制台输出
            console.log('打开活动详情:', activity);
            // 实际项目中可以在这里打开模态框或跳转到详情页
        }
    }

}
</script>

<style lang="scss" scoped>
.home-content {
    @media (max-width: 579px) {
        .hide-below-580 {
            display: none;
        }
    }

    // 表格滚动区域样式
    .h-\[320px\] {
        overflow-y: hidden;
        position: relative;

        // 固定表头
        >table:first-child {
            position: sticky;
            top: 0;
            z-index: 20;
            background-color: rgba(243, 244, 246, 0.9);
            backdrop-filter: blur(8px);
            table-layout: fixed;
            width: 100%;
        }

        .scroll-content {
            animation: scrollTable 25s linear infinite;
            animation-play-state: running;

            &.scroll-paused {
                animation-play-state: paused;
            }
        }

        // 滚动内容区域的表格
        .scroll-content table {
            table-layout: fixed;
            width: 100%;
        }

        // 设置列宽
        th:nth-child(1),
        td:nth-child(1) {
            width: 40%;
            /* 第一列：登记数据名称 */
        }

        th:nth-child(2),
        td:nth-child(2) {
            width: 20%;
            /* 第二列：所示行业 */
        }

        th:nth-child(3),
        td:nth-child(3) {
            width: 25%;
            /* 第三列：登记主体 */
        }

        th:nth-child(4),
        td:nth-child(4) {
            width: 15%;
            /* 第四列：登记日期 */
        }
    }

    @keyframes scrollTable {
        0% {
            transform: translateY(0);
        }

        100% {
            transform: translateY(calc(-100% + 320px - 60px)); // 减去表头高度
        }
    }

    // 新增：淡入动画
    .fade-in {
        animation: fadeIn 0.8s ease-out forwards;
        opacity: 0;
    }

    @keyframes fadeIn {
        from {
            opacity: 0;
            transform: translateY(10px);
        }

        to {
            opacity: 1;
            transform: translateY(0);
        }
    }

    // 新增：反向旋转动画
    @keyframes spin-reverse {
        from {
            transform: rotate(0deg);
        }

        to {
            transform: rotate(-360deg);
        }
    }

    .animate-spin-reverse {
        animation: spin-reverse 1s linear infinite;
    }

    // 新增：单行省略号样式
    .line-clamp-1 {
        overflow: hidden;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 1;
        line-clamp: 1;
    }
}
</style>